import { Button as ReducateButton, Card as ReducateCard, cn } from "@reducate/ui";
import type { ButtonProps, ButtonVariant, CardProps } from "./types/components.js";

export {
  Alert,
  AlertDescription,
  AlertTitle,
  Avatar,
  AvatarFallback,
  AvatarImage,
  Badge,
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
  CircleProgress,
  Description,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Heading,
  Input,
  Label,
  Progress,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Skeleton,
  Spinner,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Textarea,
  Field,
  FieldLabel,
  FieldDescription,
  FieldGroup,
  Radio,
  RadioGroup,
  DialogFooter,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@reducate/ui";
export { HoverCard, HoverCardContent, HoverCardTrigger } from "@reducate/ui/components/overlays/HoverCard";

const variants = {
  primary: "default",
  secondary: "secondary",
  tertiary: "ghost",
  ghost: "ghost",
  danger: "destructive",
  success: "success",
} as const satisfies Record<ButtonVariant, string>;

type ShellButtonProps = Omit<ButtonProps, "variant"> & {
  asChild?: boolean;
  variant?: ButtonVariant | "link";
};

/** Keeps the existing command and tour selectors while using Reducate presentation. */
export function Button({ controlId, variant = "primary", className, asChild, ...props }: ShellButtonProps) {
  const compact = variant === "primary" || variant === "secondary";
  return (
    <ReducateButton
      {...props}
      asChild={asChild}
      className={cn(
        variant === "link" ? "h-auto min-h-0 px-0" : compact ? "h-[32px] px-2.5 py-0" : "h-auto min-h-10 px-4 py-2.5",
        variant === "primary" ? "border-0" : variant === "secondary" ? "shadow-xs" : undefined,
        className,
      )}
      data-control-id={controlId}
      variant={variant === "link" ? "link" : variants[variant]}
    />
  );
}

const spacing = {
  none: "p-0",
  compact: "p-4",
  default: "p-5 sm:p-6",
  roomy: "p-5 sm:p-6 lg:p-7",
};

export function Card({ padding = "default", className, ...props }: CardProps) {
  return <ReducateCard {...props} className={cn("min-w-0 gap-0", spacing[padding], className)} />;
}

export { Modal } from "./components/ReducateModal.js";
export { SelectField } from "./components/ReducateSelectField.js";
